import React from 'react';
import { Navigate } from 'react-router-dom';

import AccountView from 'src/views/account/AccountView';
import ImpactView from 'src/views/impact/ImpactView';
import GuestLayout from 'src/layouts/GuestLayout';
import HomeView from 'src/views/home/HomeView';
import OrderView from 'src/views/order/OrderView';
import TeamView from 'src/views/team/TeamView';
import LoginView from 'src/views/auth/LoginView';
import RegisterView from 'src/views/auth/RegisterView';

const routes = [
  {
    path: '',
    element: <GuestLayout />,
    children: [
      { path: '', element: <Navigate to="/home" /> },
      { path: 'home', element: <HomeView /> },
      { path: 'game-order', element: <OrderView /> },
      { path: 'my-account', element: <AccountView /> },
      { path: 'your-impact', element: <ImpactView /> },
      { path: 'discover-the-team', element: <TeamView /> },
      { path: 'login', element: <LoginView /> },
      { path: 'register', element: <RegisterView /> },
      { path: '*', element: <Navigate to="/" /> }
    ]
  }
];

export default routes;
